import React from 'react';
export const SearchLogo = props => (
  <svg viewBox="0 0 451 451" width={22} height={22} {...props}>
    <path
      d="M447.05 428l-109.6-109.6c29.4-33.8 47.2-77.9 47.2-126.1C384.65 86.2 298.35 0 192.35 0 86.25 0 .05 86.3.05 192.3s86.3 192.3 192.3 192.3c48.2 0 92.3-17.8 126.1-47.2L428.05 447c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.2-5.2 5.2-13.8 0-19zM26.95 192.3c0-91.2 74.2-165.3 165.3-165.3 91.2 0 165.3 74.2 165.3 165.3s-74.1 165.4-165.3 165.4c-91.1 0-165.3-74.2-165.3-165.4z"
      fill="#858585"
    />
  </svg>
)

export const BookMarkIcon = props => (
  <svg width={23} height={40} {...props}>
    <title>{'Rectangle 30'}</title>
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="prefix__a">
        <stop stopColor="#FAD961" offset="0%" />
        <stop stopColor="#F7CB1C" offset="100%" />
      </linearGradient>
    </defs>
    <path
      d="M1122 412h15a4 4 0 0 1 4 4v34.003a2 2 0 0 1-3.5 1.322l-6.5-7.37a2 2 0 0 0-3 0l-6.5 7.37a2 2 0 0 1-3.5-1.322V416a4 4 0 0 1 4-4z"
      transform="translate(-1118 -412)"
      fill="url(#prefix__a)"
      fillRule="evenodd"
    />
  </svg>
)

export const KommunicateLogo = props => (
  <svg data-name="Layer 1" viewBox="0 0 147.735 132.997"  width={26} height={24}  {...props}>
    <path
      d="M147.714 128.428V50.764A50.764 50.764 0 0 0 96.948 0h-46.18a50.766 50.766 0 1 0 0 101.531h50.007a29.136 29.136 0 0 1 6.513 1.137 21.836 21.836 0 0 1 4.951 2.912l30.883 25.428s2.808 2.418 3.8 1.922c1.015-.51.792-4.502.792-4.502zM52.198 61.132a6.614 6.614 0 0 1-13.191 0V39.314a6.614 6.614 0 0 1 13.191 0zm28.262 10.29a6.613 6.613 0 0 1-13.189 0v-42.4a6.613 6.613 0 0 1 13.189 0zm28.266-10.29a6.614 6.614 0 0 1-13.192 0V39.314a6.614 6.614 0 0 1 13.192 0z"
      fill={props.fillcolor ? props.fillcolor : "#5553b7"}
    />
  </svg>
)

export const FourOhFourOne = props => (
  <svg data-name="Layer 1" viewBox="0 0 118.892 144.346" {...props}>
    <defs>
      <linearGradient
        id="prefix__a"
        x1={28.579}
        y1={60.532}
        x2={50.245}
        y2={64.532}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ccd9eb" />
        <stop offset={0.282} stopColor="#c9d6e9" />
        <stop offset={0.49} stopColor="#c0cee3" />
        <stop offset={0.674} stopColor="#b0c1d9" />
        <stop offset={0.844} stopColor="#99adca" />
        <stop offset={1} stopColor="#7d95b8" />
      </linearGradient>
      <linearGradient
        id="prefix__b"
        y1={108.905}
        x2={68.911}
        y2={108.905}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#aabbd4" />
        <stop offset={0.35} stopColor="#a7b8d2" />
        <stop offset={0.608} stopColor="#9eb1cc" />
        <stop offset={0.837} stopColor="#8ea3c2" />
        <stop offset={1} stopColor="#7d95b8" />
      </linearGradient>
      <linearGradient
        id="prefix__c"
        x1={98.318}
        y1={40.734}
        x2={81.318}
        y2={104.234}
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__d"
        x1={35.255}
        y1={137.579}
        x2={90.197}
        y2={137.579}
        xlinkHref="#prefix__b"
      />
      <linearGradient
        id="prefix__e"
        x1={85.706}
        y1={107.729}
        x2={68.706}
        y2={156.061}
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__f"
        x1={66.721}
        y1={117.707}
        x2={105.493}
        y2={117.707}
        xlinkHref="#prefix__b"
      />
      <linearGradient
        id="prefix__g"
        x1={76.927}
        y1={105.828}
        x2={111.139}
        y2={105.828}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#deecff" />
        <stop offset={0.488} stopColor="#e1eeff" />
        <stop offset={0.848} stopColor="#eaf3ff" />
        <stop offset={1} stopColor="#f1f7ff" />
      </linearGradient>
    </defs>
    <title>{'SVG1'}</title>
    <g
      style={{
        isolation: 'isolate',
      }}
    >
      <path
        fill="url(#prefix__a)"
        d="M54.742 42.791l28.567 9.038-24.696 36.819-28.566-9.039 24.695-36.818z"
      />
      <path
        fill="url(#prefix__b)"
        d="M40.345 107.823l28.566 9.038-40.345-6.875L0 100.948l40.345 6.875z"
      />
      <path
        fill="url(#prefix__c)"
        d="M90.326 5.698l28.566 9.038-17.96 81.122-28.567-9.037L90.326 5.698z"
      />
      <path
        fill="url(#prefix__d)"
        d="M61.631 135.308l28.566 9.038-26.376-4.495-28.566-9.039 26.376 4.496z"
      />
      <path
        fill="url(#prefix__e)"
        d="M66.721 112.318l28.566 9.038-5.09 22.99-28.566-9.038 5.09-22.99z"
      />
      <path
        fill="url(#prefix__f)"
        d="M76.927 114.058l28.566 9.038-10.206-1.74-28.566-9.038 10.206 1.74z"
      />
      <path
        fill="url(#prefix__g)"
        d="M82.572 88.561l28.567 9.038-5.646 25.497-28.566-9.038 5.645-25.497z"
      />
      <path
        d="M72.365 86.821l10.207 1.74-5.645 25.497-10.206-1.74-5.09 22.99-26.376-4.495 5.09-22.99L0 100.948l4.746-21.437L56.888 0l33.438 5.698zM45.99 82.326l8.752-39.535-24.695 36.818 15.943 2.717"
        fill="#fff"
      />
    </g>
  </svg>
)

export const FourOhFourTwo = props => (
  <svg data-name="Layer 1" viewBox="0 0 112.381 146.114" {...props}>
    <defs>
      <linearGradient
        id="prefix__a"
        x1={394.974}
        y1={361.362}
        x2={409.974}
        y2={432.113}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ccd9eb" />
        <stop offset={0.282} stopColor="#c9d6e9" />
        <stop offset={0.49} stopColor="#c0cee3" />
        <stop offset={0.674} stopColor="#b0c1d9" />
        <stop offset={0.844} stopColor="#99adca" />
        <stop offset={1} stopColor="#7d95b8" />
      </linearGradient>
      <linearGradient
        id="prefix__b"
        x1={372.501}
        y1={383.05}
        x2={411.501}
        y2={472.55}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#cedbed" />
        <stop offset={0.279} stopColor="#cbd8eb" />
        <stop offset={0.485} stopColor="#c2d0e5" />
        <stop offset={0.668} stopColor="#b2c2da" />
        <stop offset={0.836} stopColor="#9bafcc" />
        <stop offset={0.994} stopColor="#7e96b9" />
        <stop offset={1} stopColor="#7d95b8" />
      </linearGradient>
    </defs>
    <title>{'SVG2'}</title>
    <g
      style={{
        isolation: 'isolate',
      }}
    >
      <path
        d="M420.372 392.338q-6.001-27.229-11.582-33.47-3.775-4.142-10.24-3.151a12.001 12.001 0 0 0-5.85 2.33l-14.738 11.952a11.992 11.992 0 0 1 5.85-2.331q6.468-.99 10.24 3.151 5.576 6.238 11.583 33.47 6.171 27.996 3.405 34.517a8.042 8.042 0 0 1-2.491 3.493l14.737-11.951a8.028 8.028 0 0 0 2.491-3.494q2.764-6.521-3.405-34.516z"
        transform="translate(-343.646 -327.087)"
        fill="url(#prefix__a)"
      />
      <path
        d="M421.64 460.452q-21.059 3.223-34.112-6.593-7.8-5.882-13.759-17.777-5.96-11.874-11.036-34.92-8.648-39.237-.097-55.898a24.48 24.48 0 0 1 6.508-7.899l-14.739 11.951a24.502 24.502 0 0 0-6.508 7.899q-8.55 16.671.098 55.897 5.08 23.042 11.036 34.922 5.964 11.889 13.759 17.776 13.05 9.825 34.111 6.593 14.385-2.203 22.617-8.876l14.737-11.95q-8.233 6.676-22.615 8.875z"
        transform="translate(-343.646 -327.087)"
        fill="url(#prefix__b)"
      />
      <path
        d="M84.016 8.222q15.1 13.05 23.749 52.278 5.08 23.04 4.57 35.91-.504 12.88-5.271 20.69-7.83 13.021-29.07 16.265-21.06 3.223-34.112-6.593-7.8-5.883-13.759-17.777-5.96-11.874-11.036-34.921-8.648-39.236-.098-55.897Q22.585 11.138 30.972 6.7A55.885 55.885 0 0 1 48.773.821Q71.128-2.6 84.016 8.222zM80.13 99.767q2.764-6.521-3.405-34.516-6.002-27.229-11.582-33.47-3.775-4.143-10.24-3.151-6.655 1.018-8.42 6.007-2.49 6.88 3.641 34.686 6.171 27.995 11.53 33.272 3.923 3.93 10.21 2.97 6.465-.991 8.266-5.798"
        fill="#fff"
      />
    </g>
  </svg>
)

export const FourOhFourThree = props => (
  <svg data-name="Layer 1" viewBox="0 0 111.533 143.697" {...props}>
    <defs>
      <linearGradient
        id="prefix__a"
        x1={78.018}
        y1={83.509}
        x2={111.533}
        y2={83.509}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#deecff" />
        <stop offset={0.488} stopColor="#e1eeff" />
        <stop offset={0.848} stopColor="#eaf3ff" />
        <stop offset={1} stopColor="#f1f7ff" />
      </linearGradient>
      <linearGradient
        id="prefix__b"
        x1={42.635}
        y1={121.463}
        x2={67.407}
        y2={121.463}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#aabbd4" />
        <stop offset={0.35} stopColor="#a7b8d2" />
        <stop offset={0.608} stopColor="#9eb1cc" />
        <stop offset={0.837} stopColor="#8ea3c2" />
        <stop offset={1} stopColor="#7d95b8" />
      </linearGradient>
      <linearGradient
        id="prefix__c"
        x1={30.443}
        y1={89.74}
        x2={70.424}
        y2={89.74}
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__d"
        x1={48.371}
        y1={70.855}
        x2={75.102}
        y2={70.855}
        xlinkHref="#prefix__b"
      />
      <linearGradient
        id="prefix__e"
        x1={0}
        y1={108.032}
        x2={24.588}
        y2={108.032}
        xlinkHref="#prefix__b"
      />
      <linearGradient
        id="prefix__f"
        x1={50.03}
        y1={14.626}
        x2={109.668}
        y2={14.626}
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__g"
        x1={53.838}
        y1={31.393}
        x2={17.838}
        y2={89.06}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ccd9eb" />
        <stop offset={0.282} stopColor="#c9d6e9" />
        <stop offset={0.49} stopColor="#c0cee3" />
        <stop offset={0.674} stopColor="#b0c1d9" />
        <stop offset={0.844} stopColor="#99adca" />
        <stop offset={1} stopColor="#7d95b8" />
      </linearGradient>
    </defs>
    <title>{'SVG3'}</title>
    <g
      style={{
        isolation: 'isolate',
      }}
    >
      <path
        fill="url(#prefix__a)"
        d="M100.07 96.3L78.018 72.329l11.462-1.611 22.053 23.97L100.07 96.3z"
      />
      <path
        fill="url(#prefix__b)"
        d="M64.687 143.697l-22.052-23.97 2.719-20.498L67.407 123.2l-2.72 20.497z"
      />
      <path
        fill="url(#prefix__c)"
        d="M52.497 102.985l-22.054-23.97 17.928-2.52 22.053 23.971-17.927 2.519z"
      />
      <path
        fill="url(#prefix__d)"
        d="M70.424 100.466L48.371 76.495l4.678-35.25 22.053 23.972-4.678 35.249z"
      />
      <path
        fill="url(#prefix__e)"
        d="M22.053 129.574L0 105.604l2.535-19.115 22.053 23.971-2.535 19.114z"
      />
      <path
        fill="url(#prefix__f)"
        d="M72.083 29.253L50.03 5.282 87.615 0l22.053 23.971-37.585 5.282z"
      />
      <path
        fill="url(#prefix__g)"
        d="M24.588 110.46L2.535 86.489 50.03 5.282l22.053 23.971-47.495 81.207z"
      />
      <path
        d="M100.07 96.3l11.463-1.611-3.015 22.733-11.463 1.611-2.721 20.497-29.646 4.167 2.72-20.497-45.355 6.374 2.535-19.114 47.495-81.207 37.585-5.282zm-29.646 4.166l4.678-35.25-22.605 37.77 17.927-2.52"
        fill="#fff"
      />
    </g>
  </svg>
)

export const BackButton = props => (
  <svg width={10} height={17} {...props}>
    <title>{'Triangle 3'}</title>
    <path
      d="M8.5 1.5l-7 7h0l7 7"
      stroke="#FFF"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ClearButton = props => (
  <svg width={24} height={24} {...props}>
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#858585" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
)

export const NoResultsFoundSvg = props => (
  <svg viewBox="0 0 500 500" width={200} height={200} {...props}>
    <style>
      {
        '.prefix__st0,.prefix__st4{fill:none;stroke:#e6e6e6;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10}.prefix__st4{stroke-dasharray:1.91,9.5498}.prefix__st7{opacity:.3;fill:#b3b3b3}.prefix__st8{fill:#ccc}.prefix__st9{opacity:.3;fill:#999}'
      }
    </style>
    <g id="prefix__objects">
      <path className="prefix__st0" d="M88.8 312v1" />
      <path
        fill="none"
        stroke="#e6e6e6"
        strokeWidth={4}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeDasharray="1.9977 9.9887"
        d="M88.8 323v126.9"
      />
      <path className="prefix__st0" d="M88.8 454.9v1h1" />
      <path
        fill="none"
        stroke="#e6e6e6"
        strokeWidth={4}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeDasharray="2.0216 10.1082"
        d="M99.9 455.9h298.2"
      />
      <path className="prefix__st0" d="M403.2 455.9h1v-1" />
      <path
        d="M404.2 444.8V115.9c-18.7-18.7-84.7-84.5-103.4-103.2h-206"
        fill="none"
        stroke="#e6e6e6"
        strokeWidth={4}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeDasharray="2.0057 10.0284"
      />
      <path
        className="prefix__st0"
        d="M89.8 12.7h-1v1M88.8 24.7v1M300.7 12.7v1"
      />
      <path className="prefix__st4" d="M300.7 23.3v86.9" />
      <path className="prefix__st0" d="M300.7 114.9v1h1" />
      <path className="prefix__st4" d="M311.3 115.9h86.9" />
      <path className="prefix__st0" d="M402.9 115.9h1" />
      <path
        d="M481.7 479.7c.8-1.1 1.5-2.2 2.1-3.3.2-.3.3-.5.5-.8.8-1.4 1.4-2.9 2-4.4.1-.2.2-.5.2-.7.5-1.3.9-2.6 1.2-4 .1-.3.1-.6.2-.9.7-3.2 1-6.5.9-9.7v-.5c-.2-3.4-.7-6.7-1.8-9.9-1.8-5.7-4.9-11-9.4-15.5L372.8 325c-9-9-19-8.8-28.6-3.4l-19.3-19.3c0-6.1-1.9-12.1-5.6-17.2-.9-1.2-1.8-2.4-2.9-3.4l-6.9-6.9c.5-.7.9-1.4 1.4-2.1.6-.9 1.2-1.8 1.8-2.8l2.4-3.9c.6-.9 1.1-1.9 1.7-2.8.8-1.4 1.5-2.7 2.3-4.1l1.5-2.7c.8-1.5 1.6-3.1 2.3-4.7.4-.8.7-1.5 1.1-2.2 1-2.3 2-4.5 3-6.8.4-.9.7-1.8 1.1-2.8.6-1.4 1.1-2.9 1.6-4.3.4-1.1.8-2.2 1.1-3.4.4-1.3.8-2.5 1.2-3.8.1-.4.3-.8.4-1.3.2-.8.4-1.6.6-2.3.3-1.2.7-2.4 1-3.6.2-.6.3-1.2.5-1.8.2-.7.3-1.3.4-2 .3-1.2.5-2.3.8-3.5.3-1.3.5-2.6.8-4l.6-3.3c.2-1 .4-2 .5-3 .1-.4.1-.8.1-1.2.1-1 .2-2 .4-2.9.2-1.5.4-3 .5-4.5 0-.4.1-.8.1-1.2.2-2 .3-4 .4-6 .1-2.1.1-4.2.2-6.3v-.7c0-1.8 0-3.6-.1-5.4v-2-1.5l-.3-3.6c-.1-.7-.1-1.5-.2-2.2-.1-1.7-.3-3.4-.5-5.1l-.3-2.1c-.1-.9-.2-1.9-.3-2.8-.1-.8-.3-1.6-.4-2.4-.1-.6-.2-1.3-.3-1.9-.3-1.8-.6-3.6-1-5.5-.1-.4-.2-.8-.3-1.3-.3-1.6-.6-3.1-1-4.7-.6-2.6-1.3-5.2-2.1-7.7-2-6.7-4.4-13.3-7.3-19.8-.1-.3-.2-.6-.4-.8-.8-1.9-1.7-3.7-2.6-5.6l-.6-1.2c-.9-1.8-1.8-3.6-2.8-5.3-.2-.4-.4-.8-.7-1.2-1-1.8-2-3.6-3.1-5.3l-.6-.9c-1.1-1.9-2.3-3.7-3.6-5.5-5.9-8.7-12.6-16.9-20.2-24.6-2-2-4.1-4-6.2-5.9-.2-.2-.4-.3-.6-.5-1.9-1.7-3.9-3.4-5.8-5-.1-.1-.3-.2-.4-.3-2-1.6-4.1-3.3-6.2-4.8-.2-.2-.5-.3-.7-.5-2-1.5-4.1-2.9-6.1-4.3-.1-.1-.2-.1-.3-.2-64.6-42.3-152-35.2-208.7 21.5-51.4 51.5-62 128.3-31.8 190.3.2.3.3.7.5 1 1.4 2.8 2.9 5.6 4.4 8.3.2.3.3.6.5.9 3.4 5.8 7.1 11.5 11.2 16.9.5.7 1.1 1.4 1.6 2.1 1.5 2 3.1 3.9 4.8 5.9.6.7 1.2 1.5 1.9 2.2.6.7 1.3 1.5 2 2.2 1.6 1.8 3.3 3.5 5 5.2 8.1 8.1 16.8 15.2 26.1 21.3 13.8 9.1 28.7 16 44.1 20.5 10.3 3 20.8 5.1 31.4 6.1 10.6 1 21.3 1 31.8 0 10.6-1 21.1-3 31.4-6.1 2.6-.8 5.1-1.6 7.7-2.5 5.1-1.8 10.1-3.8 15-6.1 2.5-1.1 4.9-2.3 7.3-3.6 4.8-2.5 9.5-5.3 14.2-8.4 1.2-.8 2.3-1.6 3.5-2.4l6.9 6.9c.8.8 1.6 1.5 2.5 2.2 5.3 4.2 11.7 6.3 18.2 6.3l14.2 14.2 5.1 5.1c-1.6 2.8-2.7 5.7-3.3 8.5 0 .2-.1.3-.1.5-.1.8-.2 1.5-.3 2.3v2.7c0 .3 0 .6.1.9.1.6.2 1.3.3 1.9.1.3.1.6.2 1l.6 1.8c.1.3.2.7.4 1 .2.6.6 1.2.9 1.8.2.3.3.7.5 1 .4.6.8 1.2 1.3 1.8.2.3.4.6.6.8.7.9 1.5 1.8 2.3 2.6l104.9 104.9c3.5 3.5 7.4 6.1 11.7 7.9.7.3 1.3.6 2 .8 3.2 1.2 6.5 2 9.9 2.3 2.5.2 4.9.2 7.4 0 8.6-.8 17-4.5 23.6-11.1 1.2-1.2 2.2-2.4 3.2-3.7-.1-.2.2-.6.4-.9zM74.4 81.1c54.5-54.5 143-54.5 197.5 0s54.5 143 0 197.5-143 54.5-197.5 0-54.6-143 0-197.5z"
        fill="#e6e6e6"
      />
      <path
        transform="rotate(-45.001 324.729 320.458)"
        fill="#b3b3b3"
        d="M304 291h41.5v58.9H304z"
      />
      <path
        transform="rotate(-45.001 335 330.729)"
        className="prefix__st7"
        d="M314.3 315.8h41.5v29.9h-41.5z"
      />
      <path
        className="prefix__st8"
        d="M316.4 270.6l-15.9-15.9c-7 19.2-22.6 34.5-42.1 40.8l16.6 16.6c11.4 11.4 30 11.4 41.4 0s11.4-30.1 0-41.5z"
      />
      <path
        className="prefix__st7"
        d="M316.4 270.6l-15.9-15.9c-7 19.2-22.6 34.5-42.1 40.8l16.6 16.6c.8.8 1.6 1.5 2.5 2.2 11.5-15.7 25.6-29.4 41.8-40.2-.9-1.2-1.9-2.4-2.9-3.5z"
      />
      <path
        className="prefix__st8"
        d="M477.7 473.4c-15 15-39.5 15-54.5 0L318.3 368.5c-13.1-13.1-6.7-28.1 6.4-41.1l7-7c13.1-13.1 28.1-19.5 41.1-6.4l104.9 104.9c15 15 15 39.6 0 54.5z"
      />
      <path
        className="prefix__st9"
        d="M419.7 453L312.3 345.7c-2.5 7.8-1.3 15.6 6 22.9l104.9 104.9c15 15 39.5 15 54.5 0 10.5-10.5 13.6-25.7 9.4-39-8.3 25.6-42.4 43.5-67.4 18.5z"
      />
      <path
        d="M290.6 51.4c-16.3-16.3-35.1-28.5-55.1-36.6 53.2 26.6 90.4 81.8 90.4 144.4 0 87.9-73.3 161.2-161.2 161.2-69.3 0-129.5-45.6-151.9-108 7.3 27.1 21.6 52.7 42.8 73.9 64.9 64.9 170.1 64.9 234.9 0 65-64.9 65-170.1.1-234.9z"
        opacity={0.3}
        fill="#f7931e"
      />
      <path
        className="prefix__st8"
        d="M290.6 51.4c-64.9-64.9-170.1-64.9-234.9 0-64.9 64.9-64.9 170.1 0 234.9 64.9 64.9 170.1 64.9 234.9 0 64.9-64.9 64.9-170.1 0-234.9zm-18.7 216.2c-54.5 54.5-143 54.5-197.5 0s-54.5-143 0-197.5 143-54.5 197.5 0 54.5 143 0 197.5z"
      />
      <path
        className="prefix__st9"
        d="M310.8 75.9c12.3 23.3 19.3 49.7 19.3 77.5 0 92.3-77 169.3-169.3 169.3-41.8 0-80.4-15.8-110.1-41.6 1.6 1.8 3.3 3.5 5 5.2 64.9 64.9 170.1 64.9 234.9 0 57.2-57.2 63.9-145.7 20.2-210.4z"
      />
      <circle cx={173.1} cy={168.8} r={139.7} opacity={0.3} fill="#ccc" />
      <path
        d="M46.6 197.7c0-80.3 61.2-148.4 138.8-159.5-37.6-3.5-76.3 9.1-105.1 37.9-34.8 34.8-45.9 84.2-33.5 128.4-.1-2.3-.2-4.5-.2-6.8z"
        opacity={0.3}
        fill="#fff"
      />
      <path
        d="M297.3 121.8c-2.8 77.6-68.3 141.4-146.4 141.4-37.6 0-72.2-14.8-98.4-38.7 6.4 13.9 15.3 26.9 26.7 38.3 51.9 51.9 135.9 51.9 187.8 0 38.1-38.2 48.2-93.6 30.3-141z"
        opacity={0.1}
        fill="#ccc"
      />
      <path
        d="M152.6 287.6c-19.7 0-38.7-3.7-56.3-10.5 51.9 36.9 124.2 32.1 170.7-14.4 24-24 36.9-55 38.6-86.4-21.3 64.1-82.5 111.3-153 111.3z"
        opacity={0.1}
        fill="#b3b3b3"
      />
      <path
        d="M126.6 37.1l-28.7 32 17.5-7.3-9.5 22.7 19.7-29.2s0 13.1-.5 14.4c-.6 1.3 8.9-8.9 8.9-8.9l10.6 62.5 21.2 1.5-20.1 73.5 37.3 31.4-21.2-21.2 15.7-21.6 11.7 25.6-10.6-31.8-20.1 24.5-8.8-9.5 23.8-77.1-24.5-1.8 1.8-60.3 27.4 42 3.3-16.5 48.6 33.3-6.9 41.3 49.4 1.1-43.9-5.8 5.8-35.8 23-.4-9.1 20.8h40.2l-31.9-4.1 6.7-24 11.7 11.7-14.3-22.3-3.7 13.2-23-1.8L172 69.7l2.2 11.7-14.6-30.7L195.1 73 186 48.3l47 15.6-17.8-13.4 25.2-1.1-15.3-10.2c.1 0-47.3-21.1-98.5-2.1z"
        opacity={0.5}
        fill="#999"
      />
      <g opacity={0.3}>
        <path
          d="M465.6 433.6c-1.9 0-3.8-.7-5.2-2.1L358.1 331.3c-3-2.9-3-7.6-.1-10.6s7.7-3 10.6-.1l102.3 100.2c3 2.9 3 7.6.1 10.6-1.5 1.5-3.4 2.2-5.4 2.2z"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
)
